<template>
  <div class="not-found">{{$t('notFound')}}</div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
// $u: 0.01333333334;
// $h: $u * 190rem;
// .not-found{
//   width: 100%;
//   height: calc(100vh - #{$h});
//   justify-content: center;
//   align-items: center;
//   display: flex;
// }
</style>

